/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1658
 */

var r = require(/* 86 */"./1650/86/index")
var o = require(/* 1261 */"./1685/1261")
r({
  target: "Number",
  stat: true,
  forced: Number.parseInt != o
}, {
  parseInt: o
})
